import React from "react";
import PropTypes from "prop-types";

import UIButton from "../UIButton";
import UIIconMenu from "../UIIconMenu";
import { clx } from "../../../utils/Helpers";

import "./UIBulkActions.scss";

const SUCCESS_OUTLINE_KEYS = new Set([
  "approve",
  "accept",
  "approveRequests",
  "reactivate",
]);
const DESTRUCTIVE_OUTLINE_KEYS = new Set(["reject", "remove"]);

const getBulkActionButtonProps = (action) => {
  if (action.variant) {
    return {
      variant: action.variant,
      appearance: action.appearance || "default",
    };
  }

  if (SUCCESS_OUTLINE_KEYS.has(action.key)) {
    return { variant: "success", appearance: "outline" };
  }

  if (DESTRUCTIVE_OUTLINE_KEYS.has(action.key)) {
    return { variant: "destructive", appearance: "outline" };
  }

  return { variant: "outline", appearance: "default" };
};

const UIBulkActions = ({
  actions,
  menuItems,
  selectedCount,
  selectedLabel,
  className,
}) => {
  if (!selectedCount) return null;

  return (
    <div className={clx("ui-bulk-actions", className)}>
      <div className="ui-bulk-actions__buttons">
        {actions.map((action) => (
          <UIButton
            key={action.key}
            type="button"
            size="small"
            loadingLabel=""
            color={undefined}
            disabled={action.disabled}
            onClick={action.onClick}
            {...getBulkActionButtonProps(action)}
          >
            {action.label}
          </UIButton>
        ))}
        <UIIconMenu items={menuItems} ariaLabel="Bulk edit menu" />
      </div>
      <span className="ui-bulk-actions__selected">{selectedLabel}</span>
    </div>
  );
};

UIBulkActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      variant: PropTypes.oneOf([
        "primary",
        "secondary",
        "outline",
        "ghost",
        "destructive",
        "link",
        "success",
      ]),
      appearance: PropTypes.oneOf(["default", "gradient", "solid", "outline"]),
      tone: PropTypes.oneOf(["success", "danger", "primary", "neutral"]),
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  ),
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      tone: PropTypes.oneOf(["danger", "neutral"]),
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  ),
  selectedCount: PropTypes.number,
  selectedLabel: PropTypes.node.isRequired,
  className: PropTypes.string,
};

UIBulkActions.defaultProps = {
  actions: [],
  menuItems: [],
  selectedCount: 0,
  className: "",
};

export default UIBulkActions;
